// built-from: /contextual-facilitator-companion v2 impl:contextual-facilitator-companion role:implementation
import { createContext, useContext } from 'react';

export interface FacilitatorScope { engagementId: string | null; activityId?: string; openRequest?: number }
const Scope = createContext<FacilitatorScope>({ engagementId: null });
export const FacilitatorScopeProvider = Scope.Provider;
export const useFacilitatorScope = () => useContext(Scope);
